import { Intent } from "../types/chat";

/** Edit this file to customize names, copy, and example queries. */
export const branding = {
  /** Official HID logos from https://www.hidglobal.com/brand — place files in public/images/ */
  logo: {
    light: "/images/HIDLOGO.png",
    dark: "/images/HIDLOGO.png",
    alt: "HID Global",
  },
  companyName: "HID",
  productName: "DigitalPersona",
  appTitle: "Persona AI - IAMS Support Copilot",
  appSubtitle: "AI-assisted engineering for L1/L2 support",
  appVersion: "1.6.2",
  tagline: "Grounded in Jira, Confluence & Salesforce KB",
  engineerLabel: "Technical Support Engineer",
  assistantName: "DP Copilot",
  pocBadge: "Internal POC",
  disclaimer:
    "AI suggestions require human review. You are responsible for the final decision.",
  exampleQueries: [
    "Fingerprint reader not recognized on Panasonic FZ-55 after DP 4.1 upgrade",
    "Customer cannot enroll contactless card with 5022 reader",
    "High CPU usage from DPHostW.exe after upgrade to 4.1.0",
    "Browser integration not working in Chrome after DP install",
  ],
};

export const intentMeta: Record<
  Intent,
  { label: string; shortLabel: string; description: string; color: string }
> = {
  triage: {
    label: "Case Triage",
    shortLabel: "Triage",
    description: "Clarify symptoms, ask diagnostic questions, form a hypothesis",
    color: "bg-sky-500",
  },
  env_check: {
    label: "Environment Check",
    shortLabel: "Env Check",
    description: "Verify OS, DP version, reader model, GPO, and network",
    color: "bg-violet-500",
  },
  log_request: {
    label: "Log Request",
    shortLabel: "Logs",
    description: "Specify which traces and logs the customer should collect",
    color: "bg-amber-500",
  },
  troubleshoot: {
    label: "Chat",
    shortLabel: "Chat",
    description: "Step-by-step resolution grounded in KB articles",
    color: "bg-emerald-500",
  },
  ask_agent: {
    label: "Ask Agent",
    shortLabel: "Agent",
    description: "General engineering help plus indexed HID manuals/docs",
    color: "bg-indigo-500",
  },
};
